module.exports = __webpack_public_path__ + "img/hmm_logo.58d43cf7.png";